export const otherConditions = [
   'Acquired Immune Deficiency Syndrome (AIDS)',
   'Agitation of Alzheimer’s Disease',
   'Arnold-Chiari Malformation and Syringomelia',
   'Cachexia/Wasting Syndrome',
    'Causalgia',
    'Chronic Inflammatory Demyelinating Polyneuropathy',
    'CRPS (Complex Regional Pain Syndromes Type II)',
    'Dystonia',
    'Hepatitis C',
    'Hydrocephalus',
    'Interstitial Cystitis',
    'Lupus',
    'Muscular Dystrophy',
    'Myasthenia Gravis',
    'Myoclonus',
    'Nail-Patella Syndrome',
    'Neurofibromatosis',
    'Parkinson’s Disease',
    'Post Traumatic Stress Disorder (PTSD)',
    'Reflex Sympathetic Dystrophy',
    'Residual Limb Pain',
    'RSD (Complex Regional Pain Syndromes Type I)',
    'Severe Fibromyalgia',
    'Sjogren’s Syndrome',
    'Spinal Cord Disease, including but not limited to:',
    'Spinocerebellar Ataxia (SCA)',
    'Terminal Illness',
    'Tourette’s Syndrome',
]

export const spinalConditions = [
    'rachnoiditis',
    'Fibrous Dysplasia',
    'Hydromyelia',
    'Post-Concussion Syndrome',
    'Rheumatoid Arthritis (RA)',
    'Spinal Cord Injury',
    'Syringomyelia',
    'Tarlov Cysts',
    'Traumatic Brain Injury (TBI)'
]
